import ProjectScopeDocModalComponent from './scope-doc-modal.component'

const ProjectScopeDocModalModule = angular.module('cdbl.scope-doc-modal', [

])
  .component('cdblProjectScopeDocModal', ProjectScopeDocModalComponent)
  .name

export default ProjectScopeDocModalModule
